const FACETOFACE = 'FACETOFACE'
const ONLINE = 'ONLINE'

export { FACETOFACE, ONLINE }